import { useEffect } from "react";
import { useFetch } from "./useFetch";
import { useLive } from "./live";

/** Who is on these tickets (M2b), through the shared fetch layer (polish round two): read once per set of numbers, again every 30 s (the
 *  tick turns "is" into "was") and on a presence note about one of them. A note about yourself (`me`: this tab opening a ticket) changes
 *  nothing you are shown (the screens list the others), so it reads nothing. */
export type PresenceRow = { userId: string; state: "viewing" | "replying"; since: string; seenAt: string; stale: boolean };
export function usePresence(slug: string, numbers: number[], me?: string): Record<number, PresenceRow[]> {
  const key = numbers.join(",");
  const f = useFetch<Record<number, PresenceRow[]>>(key ? `/api/v1/w/${slug}/presence?numbers=${key}` : null);
  const reload = f.reload;
  useEffect(() => { if (!key) return; const t = window.setInterval(() => void reload(), 30_000); return () => clearInterval(t); }, [key, reload]);
  useLive(slug, () => void reload(), (e) => e.kind === "presence" && (!me || e.actorId !== me) && (!key || numbers.includes(e.ticketNumber ?? -1)));
  return f.data ?? {};
}
